import type { ISection } from 'src/types/menu.types';

export const moveItemBetweenSections = (
  sections: ISection[],
  itemId: string,
  fromSectionId: string,
  toSectionId: string,
  newDisplayOrder: number,
): ISection[] => {
  if (fromSectionId === toSectionId) return sections;

  const source = sections.find((section) => section.sectionId === fromSectionId);
  const hasDestination = sections.some((section) => section.sectionId === toSectionId);
  const moved = source?.items.find((item) => item.itemId === itemId);
  if (!source || !hasDestination || !moved) return sections;

  return sections.map((section) => {
    if (section.sectionId === fromSectionId) {
      return { ...section, items: section.items.filter((item) => item.itemId !== itemId) };
    }

    if (section.sectionId === toSectionId) {
      return { ...section, items: [...section.items, { ...moved, displayOrder: newDisplayOrder }] };
    }

    return section;
  });
};
